import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface ReportIssueData {
    id: number;
    reportContent: string | null;
    subject: string;
    userId: number;
    createdDate: string;
    userName: string;
    email: string;
    phoneNumber: number;
    userOperatingSystem: number;
}

export const reportIssue = async (token: string): Promise<ReportIssueData[]> => {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(`${baseUrl}/api/ReportIssue/(Admin)`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if(!response.ok) {
        throw new Error(`Failed to fetch report issue data: ${response.status}`);
    }
    const data: ReportIssueData[] = await response.json();
        return data;
}
